import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages(
    'pages.RequestFormPage.NetSuiteBillPaymentRequestForm.NetSuiteBillPaymentBillsSection',
    {
        addBillsButtonText: 'Add bills',
        removeAllBillsButtonText: 'Remove all bills',
        numberOfBills: 'NetSuite Bill Payment bills: {quantity}',
        noBillsText: 'No bills added to NetSuite Bill Payment',
        totalAmountText: 'Total',
        missingValuesWarning: 'Select Payee, Currency and A/P account to get the list of available bills',
    }
);
